import React, { useContext } from "react";
import { Box } from "@mui/material";
import SelectSchemas from "src/modules/flow-designer/vts/select-schemas/select-schemas";
import { wizardcontext } from "../../../source-configurator-tool";
import { getSchemaTypeFromDBType } from "src/modules/flow-designer/vts/selectTables-utils";
import { StepProps } from "../../source-configurator.types";
import SidebarStepFooter from "../../sidebar-step-footer";

const SelectSchemaStepPage = ({ onNext, onBack, onCancel }: StepProps) => {
    const { schemas, selectedSchemas, setState, sourceType } = useContext(wizardcontext);

    const handleSelect = (schemasSelected: typeof selectedSchemas) => {
        setState((prev: any) => ({ ...prev, selectedSchemas: schemasSelected }));
    };

    const schemaType = getSchemaTypeFromDBType(sourceType ?? "");

    return (
        <Box sx={{ width: "100%" }}>
            <SelectSchemas
                schemas={schemas}
                schemaType={schemaType}
                selectedSchemas={selectedSchemas}
                setSelectedSchemas={handleSelect}
                maxHeight={"500px"}
            />
            <SidebarStepFooter
                onCancel={onCancel}
                onBack={onBack}
                onNext={onNext}
                nextDisabled={selectedSchemas.length === 0}
            />
        </Box>
    );
};

export default SelectSchemaStepPage;
